const STORAGE_KEY = 'wafer_inventory:dismissed_efem_terminal';

type DismissedEfemTerminalJobs = {
  scanJobIds: string[];
  transferJobIds: string[];
};

function read(): DismissedEfemTerminalJobs {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { scanJobIds: [], transferJobIds: [] };
    }
    const parsed = JSON.parse(raw) as DismissedEfemTerminalJobs;
    return {
      scanJobIds: Array.isArray(parsed.scanJobIds) ? parsed.scanJobIds : [],
      transferJobIds: Array.isArray(parsed.transferJobIds) ? parsed.transferJobIds : [],
    };
  } catch {
    return { scanJobIds: [], transferJobIds: [] };
  }
}

function write(data: DismissedEfemTerminalJobs): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function isScanTerminalDismissed(jobId: string): boolean {
  return read().scanJobIds.includes(jobId);
}

export function isTransferTerminalDismissed(jobId: string): boolean {
  return read().transferJobIds.includes(jobId);
}

export function dismissScanTerminal(jobId: string): void {
  const data = read();
  if (!data.scanJobIds.includes(jobId)) {
    data.scanJobIds.push(jobId);
    write(data);
  }
}

export function dismissTransferTerminal(jobId: string): void {
  const data = read();
  if (!data.transferJobIds.includes(jobId)) {
    data.transferJobIds.push(jobId);
    write(data);
  }
}

export function efemScanNotificationId(jobId: string): string {
  return `efem_scan_terminal_${jobId}`;
}

export function efemTransferNotificationId(jobId: string): string {
  return `efem_transfer_terminal_${jobId}`;
}

const TRANSFER_PREFIX = 'efem_transfer_terminal_';
const SCAN_PREFIX = 'efem_scan_terminal_';

/** Persist dismiss when closing an EFEM terminal notification from the bell menu. */
export function dismissEfemNotificationById(notificationId: string): void {
  if (notificationId.startsWith(TRANSFER_PREFIX)) {
    dismissTransferTerminal(notificationId.slice(TRANSFER_PREFIX.length));
  } else if (notificationId.startsWith(SCAN_PREFIX)) {
    dismissScanTerminal(notificationId.slice(SCAN_PREFIX.length));
  }
}
